import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import { useNavigate } from "react-router-dom";

export const Auth0ProviderWithNavigate = ({ children }) => {
  const navigate = useNavigate();

  //const domain = "fastlink-dev.us.auth0.com";
  //const clientId = "n58RKIRSSgcylMjvxPa54zqyQteKSddA";
  const redirectUri = `${window.location.origin}/home`;
  //const audience  = "https://fastlink-api.com/";
  const scope = "openid profile email";
  const authDomain =window.REACT_APP_AUTH0_DOMAIN;
  const authClientId =window.REACT_APP_AUTH0_CLIENT_ID;
  const authApi =window.REACT_APP_AUTH0_API;


  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  if (
    !(
      authDomain &&
      authClientId &&
      redirectUri
    )
  ) {
    return null;
  }

  return (
    <Auth0Provider
      domain={authDomain}
      clientId={authClientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: authApi,
        scope: scope,
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      {children}
    </Auth0Provider>
  );
};
